<template lang="html">
    <div>
        <v-layout align-center justify-end row fill-height>
          <v-btn large color="success" @click="clickExport()">Exportar CSV</v-btn>
        </v-layout>

        <!-- List Emails -->
        <div>
          <v-layout v-for="email in newsletterEmails" :key="email.id" class="emailRow py-2">
            <!-- Col1 - Label -->
            <v-flex grow>
              {{email.email}}
            </v-flex>

            <!-- Col2 - Actions -->
            <v-flex shrink>
              <v-icon class="pointer" @click="askDeleteEmail(email)">delete</v-icon>
            </v-flex>

          </v-layout>
        </div>

        <v-dialog
          v-if="selectedEmail"
          v-model="showDeleteDialog"
          max-width="290"
        >
          <v-card>
            <v-card-title class="headline">Apagar email "{{selectedEmail.email}}?"</v-card-title>

            <v-card-text>
              Atenção: Esta ação não é reversível.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="closeDeleteDialog"
              >
                Cancelar
              </v-btn>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="confirmDelete()"
              >
                Continuar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  created: function () {
    this.downloadNewsletterEmails()
  },
  data: function () {
    return {
      showDeleteDialog: false,
      selectedEmail: null
    }
  },
  methods:{
    ...mapActions([
      'downloadNewsletterEmails',
      'deleteNewsletterEmail',
      'downloadNewsletterEmailsCSV'
    ]),
    clickExport: function () {
      this.downloadNewsletterEmailsCSV()
    },
    askDeleteEmail: function (email) {
      this.selectedEmail = email
      this.showDeleteDialog = true
    },
    closeDeleteDialog: function () {
      this.showDeleteDialog = false
    },
    confirmDelete: function () {
      this.deleteNewsletterEmail(this.selectedEmail).then(() => {
        this.downloadNewsletterEmails()
      })
      this.showDeleteDialog = false
    },
  },
  computed: {
    ...mapGetters([
      'getCurrentNewsletterArray'
    ]),
    newsletterEmails: function () {
      return this.getCurrentNewsletterArray
    }
  },
}
</script>

<style lang="scss" scoped>
.emailRow{
  &:hover{
    background-color: #F5F5F5;
  }
}
</style>
